import {push} from 'connected-react-router'
import {useDispatch} from 'react-redux'
import {fetchMyApplicationData} from '../redux/slice/collectionApplicationSlice'
import {
    createNewBusinessApplicationForApplicationType,
    fetchLicenceTypeDetails,
    setLicenceApplicationPaymentStatus
} from '../redux/slice/primaryAgencyApplicationSlice'
import { useEffect } from 'react'
import { 
    resetNextUrl, 
    resetSegueDetails, 
    scrollWindowDown 
} from '../redux/slice/primaryAgencyApplicationSlice'
import { getAccountInfo } from '../redux/slice/userAuthSlice'
import { replaceUrlParams, storageAvailable } from '../app/utils'
import { 
    APPLICATION_MODE_NEW,
    APPLICATION_MODE_RENEW,
    APPLICATION_STATUS_PENDING_PAYMENT,
    APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_COLLECTOR,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    AUTHORITY_BUSINESS_LICENCE_ADMIN,
    ERROR_CODE,
    PAYMENT_STATUS_FAILURE, 
    ROUTE_PATH, 
    SEGUE_NAME
} from '../app/constants'
import { useState } from 'react'
import { 
    applicationTypeFromLicenceSubType,
    isAgencyTypeApplication,
    isApplicationProcessingInProgress,
    isPaymentProcessedSuccessfully,
    isRenewalTypeApplication 
} from '../redux/slice/applicationsUtils'
import { fetchArchiveApplicationsForOriginalId } from '../redux/slice/archiveApplicationsSlice'
import { startNSLogout } from '../redux/slice/nsLoginSlice'

const LAUNCH_STAGES = { 
    INIT : "init",
    ACCOUNT_DETAILS : "account_details",
    APPLICATION_DETAILS : "application_details",
    LICENCE_TYPE_DETAILS : "licence_type_details",
    ARCHIVE_DATA : "archive_data",
    ERROR : "error",
    SUCCESS : "success"
}

const LaunchPage = (props) => {
    const dispatch = useDispatch()

    const [launchStage, setLaunchStage] = useState(LAUNCH_STAGES.INIT)
    const [statusMessage, setStatusMessage] = useState("...")
    const [needToRedirect,setNeedToRedirect] = useState(false);
    const [redirectApplicationType,setRedirectApplicationType] = useState(null);
    const [agencyApplicationResponse, setAgencyApplicationResponse] = useState(null);
    const [additionalApplicationResponse, setAdditionalApplicationResponse] = useState(null);
    const segueString = window.sessionStorage.getItem("segue")
    const segueDetails = segueString ? JSON.parse(segueString) : null
    const storedUrl = window.sessionStorage.getItem("nextUrl")

    if (!storageAvailable('sessionStorage')) {
        console.error("sessionStorage is not available!!")
    }
    
    const urlQuery = new URLSearchParams(props.location.search);
    let applicationType = urlQuery.get("applicationType")
    let applicationMode = urlQuery.get("applicationMode")

    if(!applicationType) {
        if(segueDetails && segueDetails.applicationType) {
            applicationType = segueDetails.applicationType
        } else { 
            applicationType = APPLICATION_TYPE_COLLECTION_AGENCY
        }
    }

    if(!applicationMode) { 
        if(segueDetails && segueDetails.applicationMode) {
            applicationMode = segueDetails.applicationMode
        } else {
            applicationMode = APPLICATION_MODE_NEW
        }
    }

    useEffect(() => {
        if(launchStage === LAUNCH_STAGES.INIT) {
            
            if(segueDetails && segueDetails.name === SEGUE_NAME.LOGOUT) { 

                dispatch(resetSegueDetails())
                
                // need to go back to the launch pages of the respective applications
                switch(segueDetails.applicationType) { 
                    case APPLICATION_TYPE_COLLECTION_AGENCY :
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_COLLECTION_AGENCY) 
                        break
                    case APPLICATION_TYPE_COLLECTOR : 
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_COLLECTOR)
                        break
                    case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY :
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_DEBT_MANAGEMENT_AGENCY) 
                        break
                    case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT :
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_DEBT_MANAGEMENT_AGENT) 
                        break
                    case APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN :
                        let path = `${window.location.protocol}//${window.location.host}/#${ROUTE_PATH.BLT_LOGIN}`
                        window.location.assign(path)
                        break
                    case APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE : 
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE) 
                        break
                    case APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE : 
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_LENDER)
                        break
                    case APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE : 
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_ADMINISTRATOR)
                        break
                    default :
                        window.location.assign(ROUTE_PATH.LAUNCHPAGE_COLLECTION_AGENCY) 
                        break
                }
            } else { 
                runLaunchSequence()
            }
        }
    })

    /*
     * first time creation of application
     */
    const handleCreateNewApplication = () => {
        if(segueDetails) { 
                
            dispatch(resetSegueDetails())

            if(segueDetails.name === SEGUE_NAME.LOGIN) { 
                let appType = segueDetails.applicationType
                let appMode = segueDetails.applicationMode

                // create new business application for the application type
                dispatch(createNewBusinessApplicationForApplicationType(appType))

                if(appType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                    dispatch(push(ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_BROKER_NEXT_STEPS))
                } else if(appType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) { 
                    dispatch(push(ROUTE_PATH.ML_APP + ROUTE_PATH.ML_NEXT_STEPS))
                } else if(appType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) { 
                    dispatch(push(ROUTE_PATH.MA_APP + ROUTE_PATH.ML_NEXT_STEPS))
                } else if(appType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE
                    || appType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE) {
                    dispatch(push(ROUTE_PATH.PB_APP + ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION))
                } else if(appType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE
                    || appType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE) {
                    dispatch(push(ROUTE_PATH.CO_APP + ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION))
                }
                else { 
                    dispatch(push(replaceUrlParams(ROUTE_PATH.RJSC_SEARCH, appType, appMode)))
                }
                return
            } else { 
                console.warn("unknown segue : " + segueDetails.name)
            }
        } else if(storedUrl) {
            // THIS IS NOT DESIRED OPTION, BECAUSE THE APPLICATION TYPE IS NOT KNOW
            dispatch(createNewBusinessApplicationForApplicationType(applicationType))
            dispatch(resetNextUrl())
            dispatch(push(storedUrl))
        } else { 
            // create new business application for the application type
            dispatch(createNewBusinessApplicationForApplicationType(applicationType))
            dispatch(push(replaceUrlParams(ROUTE_PATH.RJSC_SEARCH, applicationType, applicationMode)))
        }
    }

    // fetch the archive application, if today is within the renewal range
    
    /* 
     * application created once but not paid yet
     */
    const handlePaymentSegue = (segueDetails, applicationType, applicationMode, agencyApplication, additionalApplications) => {
        
        const appType = segueDetails?.applicationType ?? applicationType
        const appMode = segueDetails?.applicationMode ?? applicationMode
        
        const navigateForPaymentFailure = (paymentDetails) => {
            let nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, appType, appMode)
            let scrollWindow = false
            if(appType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) { 
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_RENEWAL_PAYMENT_REVIEW
                } else {
                    nextUrl = ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_PAYMENT_PREVIEW
                }
            } else if (appType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.ML_APP + ROUTE_PATH.RENEWAL_PAYMENT_PREVIEW
                } else {
                    nextUrl = ROUTE_PATH.ML_APP + ROUTE_PATH.ML_PAYMENT_PREVIEW
                }
            } else if (appType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.MA_APP + ROUTE_PATH.RENEWAL_PAYMENT_PREVIEW
                } else {
                    nextUrl = ROUTE_PATH.MA_APP + ROUTE_PATH.ML_PAYMENT_PREVIEW
                }
            } else { 
                nextUrl = replaceUrlParams(ROUTE_PATH.PAYMENT_PREVIEW, appType, appMode)
            }
            scrollWindow = true

            dispatch(resetSegueDetails())
            dispatch(push({
                pathname : nextUrl, 
                state : {
                    paymentDetails
                }
            }))
            
            //  in case payment was unsuccessful, show error at the bottom of the payment screen.
            if(scrollWindow) {
                setTimeout(() => {
                    dispatch(scrollWindowDown())
                }, 100)
            }
        }

        const navigateForPaymentSuccess = (applicationIds) => {
            let nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, appType, appMode)
            let pushState = {}
            // payment was successful if flow is here.
            // pass a flag to the Welcome screen to show a payment confirmation message.
            if(appType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_RENEWAL_PAYMENT_CONFIRMATION
                    pushState = {
                        applicationIds 
                    }
                } else {
                    nextUrl = ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_PAYMENT_CONFIRMATION
                }
            } else if (appType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.ML_APP + ROUTE_PATH.RENEWAL_PAYMENT_CONFIRMATION
                } else {
                    nextUrl = ROUTE_PATH.ML_APP + ROUTE_PATH.ML_PAYMENT_CONFIRMATION
                }
            } else if (appType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
                if(appMode === APPLICATION_MODE_RENEW) {
                    nextUrl = ROUTE_PATH.MA_APP + ROUTE_PATH.RENEWAL_PAYMENT_CONFIRMATION
                } else {
                    nextUrl = ROUTE_PATH.MA_APP + ROUTE_PATH.ML_PAYMENT_CONFIRMATION
                }
                
            } else {
                if(segueDetails.showBranchPaymentConfirmation) {
                    nextUrl = replaceUrlParams(ROUTE_PATH.BRANCH_APPLICATION_PAYMENT_CONFIRMATION, appType,appMode)
                } else {
                    nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, appType, appMode)
                    pushState = {
                        showPaymentConfirmation : true
                    }
                }
            }
            
            dispatch(resetSegueDetails())
            dispatch(push({
                pathname : nextUrl, 
                state : pushState
            }))
        }

        const paymentRequestDetailsStr = window.sessionStorage.getItem("paymentRequestDetails")
        const paymentDetails = paymentRequestDetailsStr ? JSON.parse(paymentRequestDetailsStr) : null 
        
        if(paymentDetails) {
            // 1. check the applicationIds sent for the payment request
            // 2. for each application, find out the status
            // 3. if any one of application status is not what it should be after the payment, 
            //    then there is some error in the payment

            const allApplicationsProcessed = paymentDetails.every(({applicationId}) => {
                if(agencyApplication?.id === applicationId) {
                    return isPaymentProcessedSuccessfully(agencyApplication)
                } else {
                    // AdditionalApp could be branchApplication or agentApplication
                    const additionalApp = additionalApplications?.find(app => app.id === applicationId)
                    if(additionalApp) {
                        return isPaymentProcessedSuccessfully(additionalApp)
                    } else {
                        console.warn("additional application not found for applicationId: ", applicationId)
                    }
                }
                return false
            })

            if(allApplicationsProcessed) {
                navigateForPaymentSuccess(paymentDetails)
            } else {
                dispatch(setLicenceApplicationPaymentStatus(PAYMENT_STATUS_FAILURE))
                navigateForPaymentFailure(paymentDetails)
            }
        } else {
            console.warn("paymentDetails not found!")
            // TODO : check the applicationStatus of all the applications 
            // whose payment was tried. 
            // case 1 : agency application + collector applications 
            //          Failure will be for the entire submission so 
            //          just checking for main agency application status 
            //          should be enough.
            // case 2 : only collector application
            //          Failure will be only for those applications submitted 
            //          for payment. We need ids of the application submitted 
            //          for payment and check applicationStatus for any of the 
            //          applications submitted and decide if it was a failure.
            if(agencyApplication?.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT) { 
                // looks like payment did not go through successfully
                dispatch(setLicenceApplicationPaymentStatus(PAYMENT_STATUS_FAILURE))
                navigateForPaymentFailure()
            } else { 
                navigateForPaymentSuccess()
            }
        }
    }

    const handleReturnToCreatedApplication = (data, additionalApplications) => {
        // The licencingSubType will decide what type of application this user has created.
        
        const applicationTypeFromResponse = mergeRetentionApplicationTypes(applicationTypeFromLicenceSubType(data.licencingSubType));

        if(applicationType !== applicationTypeFromResponse) {
            console.warn(`Changing Application Type to ${applicationType} instead of ${applicationTypeFromResponse} based on licence sub type created earlier.`)
        }

        // 2. if nothing is requested, check if nextUrl is set
        //    check if any data is available
        // 3. if application details are available, then go to the welcome page.
        if(segueDetails) {
            if(segueDetails.name === SEGUE_NAME.PAYMENT) {
                handlePaymentSegue(segueDetails, applicationType, applicationMode, data, additionalApplications)
            } else {
                const nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, applicationTypeFromResponse, applicationMode)
                
                dispatch(resetSegueDetails())
                dispatch(push(nextUrl))
            }
        }
        else if(storedUrl) {
            dispatch(resetNextUrl())
            dispatch(push(storedUrl))
        }
        else {
            // move on to the page requested
            if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                dispatch(push(ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_BROKER_NEXT_STEPS))
            } else {
                /* Replaced applicationType by applicationTypeFromResponse, since applicationType was not redirecting to correct url when 
                 wrong application-type is ued in the url bar used for an  application  */
                dispatch(push({
                    pathname : replaceUrlParams(ROUTE_PATH.WELCOME, applicationTypeFromResponse, applicationMode), 
                    state : {showPaymentConfirmation: false}
                }))
            }
        }
    }

    const handleSignout = () => { 
        dispatch(startNSLogout(applicationType,applicationMode))
    }

    const isUserBusinessAdmin = (user) => { 
        if(user.authorities && Array.isArray(user.authorities)) {
            for(let i = 0; i < user.authorities.length; i++) {
                let auth = user.authorities[i]
                if (auth.authority === AUTHORITY_BUSINESS_LICENCE_ADMIN)  {
                    return true
                }
            }
        }

        return false
    }

    const mergeRetentionApplicationTypes = (applicationType) => {
        if(applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE)
            return APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE
        else if(applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE)
            return APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE
        return applicationType;
    }

    const validateApplicationTypeWithLicenceSubType = (application) => {
        const appType = mergeRetentionApplicationTypes(applicationTypeFromLicenceSubType(application.licencingSubType))
        return (applicationType === appType)
    }

    /* 
     * For BUSINESS_USER type logins : 
     * step 1 : fetch the application data
     * step 2 : fetch the licence type details from the application data.
     *          This is to know if the current date is within the renewal date range.
     * step 3 : fetch the archive data if user has already started working on the renewal.
     * 
     * For ADMIN type logins : 
     * go to the home queue after validating the user account
     */
    const runLaunchSequence = () => {
        // check if session is valid
        setStatusMessage("fetching account details...")
        //console.log("fetching account details...")

        setLaunchStage(LAUNCH_STAGES.ACCOUNT_DETAILS)
        dispatch(getAccountInfo())
        .then((payload) => {
            if(payload.username) {
                if(applicationType === APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN) {
                    if(segueDetails) {
                        dispatch(resetSegueDetails())
                    }

                    if(isUserBusinessAdmin(payload)) {
                        dispatch(push(ROUTE_PATH.BLT_HOME))
                    } else { 
                        setLaunchStage(LAUNCH_STAGES.ERROR)
                        setStatusMessage("{invalid user}")
                    }
                } else { 
                        setStatusMessage("fetching application details...")
                        
                        setLaunchStage(LAUNCH_STAGES.APPLICATION_DETAILS)
                        
                        dispatch(fetchMyApplicationData(true))
                            .then(({agencyApplication, additionalApplications}) => {
                                setAgencyApplicationResponse(agencyApplication);
                                setAdditionalApplicationResponse(additionalApplications);
                                let redirectRequired = false;
                                let data = agencyApplication
                                if(data && data.id > 0) {

                                    if(!validateApplicationTypeWithLicenceSubType(data)) {
                                        redirectRequired = true;
                                        setLaunchStage(LAUNCH_STAGES.ERROR);
                                        setNeedToRedirect(true);
                                        setRedirectApplicationType(applicationTypeFromLicenceSubType(data.licencingSubType));
                                    }

                                    setStatusMessage("fetching licence details...")
                                    setLaunchStage(LAUNCH_STAGES.LICENCE_TYPE_DETAILS)
                                    dispatch(fetchLicenceTypeDetails(data.licencingSubType))
                                        .then(licenceData => {
                                            if(isAgencyTypeApplication(data) && 
                                                    isRenewalTypeApplication(data) && 
                                                    (isApplicationProcessingInProgress(data) || 
                                                        data.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)) {
                                                setStatusMessage("fetching other details...")
                                                setLaunchStage(LAUNCH_STAGES.ARCHIVE_DATA)
                                                dispatch(fetchArchiveApplicationsForOriginalId(data.id))
                                                    .then(archiveData => {
                                                        //console.log("archive data fetched...")
                                                    })
                                                    .catch(error => {
                                                        console.error(error)
                                                    })
                                                    .finally(() => {
                                                        if(!redirectRequired) {
                                                            handleReturnToCreatedApplication(agencyApplication, additionalApplications)
                                                        }
                                                        setLaunchStage(LAUNCH_STAGES.SUCCESS)
                                                    })
                                            } else {
                                                if(!redirectRequired) {
                                                    handleReturnToCreatedApplication(agencyApplication, additionalApplications)
                                                }
                                                setLaunchStage(LAUNCH_STAGES.SUCCESS)
                                            }
                                        })
                                        .catch(error => {
                                            console.error("licence type data fetch error", error)
                                            setLaunchStage(LAUNCH_STAGES.ERROR)
                                            setStatusMessage(`{Error : could not fetch all data. Please try again later.}`)
                                        })
                                } else {
                                    handleCreateNewApplication()
                                    setLaunchStage(LAUNCH_STAGES.SUCCESS)
                                }
                            })
                            .catch(error => {
                                if(error === ERROR_CODE.EMPTY_RESPONSE) { 
                                   // this has to be due to login segue
                                   handleCreateNewApplication()
                                }
                            })
                }
            } else {
                // show privacy notice page & let user login first
                setLaunchStage(LAUNCH_STAGES.SUCCESS)
                if(applicationType === APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN) {
                    dispatch(push(ROUTE_PATH.BLT_LOGIN))
                }
                else if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
                    || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) { 
                    dispatch(push(replaceUrlParams(ROUTE_PATH.PRIVACY_NOTICE, applicationType, applicationMode)))
                }
                else if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                    dispatch(push(replaceUrlParams(ROUTE_PATH.MRA_APP, applicationType, applicationMode)))
                } 
                else { 
                    setLaunchStage(LAUNCH_STAGES.ERROR)
                    setStatusMessage(`{Error : invalid applicationType ${applicationType}. Please check url.}`)
                }
            }
        })
        .catch((error) => {
            // will get 401 - Unauthorized if login is not valid
            console.log(error)
            setLaunchStage(LAUNCH_STAGES.SUCCESS)
            
            if(applicationType === APPLICATION_TYPE_BUSINESS_LICENCE_ADMIN) {
                dispatch(push(ROUTE_PATH.BLT_LOGIN))
            }
            else if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
                || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) { 
                dispatch(push(replaceUrlParams(ROUTE_PATH.PRIVACY_NOTICE, applicationType, applicationMode)))
            } else if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                dispatch(push(replaceUrlParams(ROUTE_PATH.MRA_APP, applicationType, applicationMode)))
            }else { 
                setLaunchStage(LAUNCH_STAGES.ERROR)
                setStatusMessage(`{Error : invalid applicationType ${applicationType}. Please check url.}`)
            }
        })
    }

    const applicationTypeString = (type) => {
        switch(type) {
            case APPLICATION_TYPE_COLLECTION_AGENCY: 
                return 'Collection Agency';
            case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY:
                return 'Debt Management Agency';
            case APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE:
                return 'Mortgage Brokerage';
            case APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE:
                return 'Mortgage Lender';
            case APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE:
                return 'Mortgage Administrator';
            default:
                return type;
        }
    }

    if(needToRedirect) {
        return (
            <>
                <div className="container collectionServiceContainer">
                    <div className="row topMarginNormal">
                        <div className="col-xs-12">
                            <h1>Redirect</h1>
                            <p className="topMarginMedium">
                                {`You are attempting to log into ${applicationTypeString(applicationType)} service with your ${applicationTypeString(redirectApplicationType)} login. 
                                Use Continue to be redirected to the ${applicationTypeString(redirectApplicationType)} service, or contact business licencing for the correct link.`}
                            </p>
                        </div>
                    </div>
                    <div className="row topMarginMedium">
                        <div className="col-xs-2">
                            <button 
                                id="navigate-agency"
                                className="btn-lg btn-primary"
                                onClick={() => {
                                    handleReturnToCreatedApplication(agencyApplicationResponse, additionalApplicationResponse);
                                }}>
                                Continue
                            </button>
                        </div>
                        <div className="col-xs-2">
                            <button id="signoutButton" className="btn-lg btn-primary" onClick={handleSignout}>
                                Sign out
                            </button>
                        </div>
                    </div>
                    <div className="row topMarginMedium">
                        <div style={{border: '1px solid lightgray', padding: "10px 20px"}}>
                            <h1>Contact Business Licencing</h1>
                            <p>Business licencing offices are open Monday to Friday from 8:30am to 4:30pm Atlantic Time.</p>
                            <p>
                                <div>Phone: 902-424-5200</div>
                                <div>Toll-free: 1-800-670-4357</div>
                                <div>General enquiries: reglicensing@novascotia.ca</div>
                                <div>Mortgage licencing enquiries: MortgageRegulation@novascotia.ca</div>
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    
    return (
        <>
            <div className={"container"}>
                <div className="row topMarginLarge">
                    <div className="col-12 centered">
                        <p className="statusText">
                            {statusMessage}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LaunchPage